import { render, staticRenderFns } from "./add-voucher.vue?vue&type=template&id=87f6e68a&scoped=true&"
import script from "./add-voucher.vue?vue&type=script&lang=js&"
export * from "./add-voucher.vue?vue&type=script&lang=js&"
import style0 from "./add-voucher.vue?vue&type=style&index=0&id=87f6e68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f6e68a",
  null
  
)

export default component.exports